var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebApplication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "#FFF2E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 16.25H13.3334M12.1667 16.25C11.6835 16.25 11.2917 15.8582 11.2917 15.375V13.9167H11.0001M12.1667 16.25H9.83341M11.0001 13.9167H10.7084V15.375C10.7084 15.8582 10.3166 16.25 9.83341 16.25M11.0001 13.9167V16.25M9.83341 16.25H8.66675",
    stroke: "#E78D3E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 5.75H8.66675C7.01683 5.75 6.19187 5.75 5.67931 6.26256C5.16675 6.77513 5.16675 7.60008 5.16675 9.25V10.4167C5.16675 12.0666 5.16675 12.8915 5.67931 13.4041C6.19187 13.9167 7.01683 13.9167 8.66675 13.9167H13.3334C14.9833 13.9167 15.8083 13.9167 16.3208 13.4041C16.8334 12.8915 16.8334 12.0666 16.8334 10.4167V9.25C16.8334 7.60008 16.8334 6.77513 16.3208 6.26256C15.8083 5.75 14.9833 5.75 13.3334 5.75Z",
    stroke: "#E78D3E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApplication);
export default __webpack_public_path__ + "static/media/web_application.cd1f191081d2768aae938bde2c8974c4.svg";
export { ForwardRef as ReactComponent };